export default __webpack_public_path__ + "static/media/banner-1.b33b5635.jpg";